import script from "./Image.vue?vue&type=script&setup=true&lang=js"
export * from "./Image.vue?vue&type=script&setup=true&lang=js"

import "./Image.vue?vue&type=style&index=0&id=14cca404&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14cca404"]])

export default __exports__